const HOTJAR_ID = process.env.REACT_APP_HOTJAR_ID; // numeric string
const HOTJAR_SV = process.env.REACT_APP_HOTJAR_SNIPPET; // typically "6"
const SCRIPT_ID = "hotjar-script";

export function enableHotjar() {
  if (!HOTJAR_ID || !HOTJAR_SV) return;
  if (document.getElementById(SCRIPT_ID)) return;

  // Hotjar’s recommended approach is to only install the tracking code after consent.  [oai_citation:1‡help.hotjar.com](https://help.hotjar.com/hc/en-us/articles/36820043878161-What-is-a-Hotjar-User-ID)
  (function (h, o, t, j, a, r) {
    h.hj =
      h.hj ||
      function () {
        (h.hj.q = h.hj.q || []).push(arguments);
      };
    h._hjSettings = { hjid: Number(HOTJAR_ID), hjsv: Number(HOTJAR_SV) };
    a = o.getElementsByTagName("head")[0];
    r = o.createElement("script");
    r.async = 1;
    r.id = SCRIPT_ID;
    r.src = t + h._hjSettings.hjid + j + h._hjSettings.hjsv;
    a.appendChild(r);
  })(window, document, "https://static.hotjar.com/c/hotjar-", ".js?sv=");
}

export function disableHotjar() {
  // Best-effort:
  // 1) remove script
  const s = document.getElementById(SCRIPT_ID);
  if (s && s.parentNode) s.parentNode.removeChild(s);

  // 2) clear common global handles
  try {
    if (window.hj && window.hj.q) window.hj.q = [];
  } catch {
    // ignore
  }
}
